<template>
    <div class="container-fluid">
        <div class="bgloading" v-if="isLoading"><Loader></Loader></div>
        <div class="row" v-else>
            <div class="col-md-12">
                <div class="container">
                    <form @submit.prevent="form">
                        <div class="card" style="margin-top: 10px">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-5">
                                        <h3 class="tituloJobs">Formulario para Agregar Monitor</h3>
                                    </div>
                                    <div class="col-7 text-right">
                                        <button
                                            type="submit"
                                            class="btn btn-success"
                                            :disabled="btnSave"
                                        >
                                            <i class="fas fa-save"></i> Guardar
                                        </button>
                                        <button
                                            type="button"
                                            @click="cancel"
                                            class="btn btn-light"
                                            style="margin-left: 10px"
                                        >
                                            <i class="fas fa-times"></i> Cancelar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label>Plantilla:</label>
                                                    <model-select
                                                        :options="TypeTemplates"
                                                        v-model="f.TypeTemplates"
                                                        @input="handleOnInput"
                                                    ></model-select>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>Nombre:</label>
                                                    <textarea
                                                        v-model="f.name"
                                                        class="form-control"
                                                        rows="2"
                                                        style="
                                                            overflow: hidden;
                                                            max-height: 51px;
                                                        "
                                                        :maxlength="50"
                                                        v-on:keypress.enter="validarEnter"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label>Fecha de inicio:</label>
                                                    <datetime
                                                        required
                                                        type="datetime"
                                                        v-model="f.dpublis"
                                                        :format="{
                                                            year: 'numeric',
                                                            month: 'short',
                                                            day: 'numeric',
                                                            hour: 'numeric',
                                                            minute: '2-digit',
                                                        }"
                                                        use12-hour
                                                        value-zone="America/New_York"
                                                        input-class="form-control jobdate"
                                                    ></datetime>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>Fecha final:</label>
                                                    <datetime
                                                        type="datetime"
                                                        v-model="f.dfinish"
                                                        :format="{
                                                            year: 'numeric',
                                                            month: 'short',
                                                            day: 'numeric',
                                                            hour: 'numeric',
                                                            minute: '2-digit',
                                                        }"
                                                        use12-hour
                                                        value-zone="America/New_York"
                                                        input-class="form-control jobdate"
                                                    ></datetime>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <div
                                                                class="input-group-text url-text"
                                                            >
                                                                {{
                                                                    urlDisplay +
                                                                    org_id +
                                                                    "/"
                                                                }}
                                                            </div>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            class="form-control url-input"
                                                            v-model="f.url"
                                                            placeholder="url-name"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label>PIN de Seguridad:</label>
                                                    <input
                                                        type="number"
                                                        class="form-control"
                                                        v-model="f.pin"
                                                        min="0"
                                                        max="999999"
                                                        maxlength="6"
                                                    />
                                                </div>
                                                <div class="col-md-6">
                                                    <label>Estado:</label>
                                                    <select
                                                        class="form-control"
                                                        v-model="f.status"
                                                    >
                                                        <option value="1">Activo</option>
                                                        <option value="0">
                                                            Inactivo
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="form-group"
                                            v-if="orientation === false"
                                        >
                                            <label>Orientación:</label>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="flex-container">
                                                        <div>
                                                            <label
                                                                ><input
                                                                    type="radio"
                                                                    class="horisontal"
                                                                    v-model="
                                                                        f.orientation
                                                                    "
                                                                    :value="1"
                                                                    :checked="
                                                                        f.orientation === 1
                                                                    "
                                                                    style="
                                                                        margin-left: 8px;
                                                                        cursor: pointer;
                                                                    "
                                                            /></label>
                                                        </div>
                                                        <div>
                                                            <label
                                                                ><input
                                                                    type="radio"
                                                                    class="vertical"
                                                                    v-model="
                                                                        f.orientation
                                                                    "
                                                                    :value="2"
                                                                    :checked="
                                                                        f.orientation === 2
                                                                    "
                                                                    style="
                                                                        margin-left: 8px;
                                                                        cursor: pointer;
                                                                    "
                                                            /></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <div
                                                v-if="Showimg1"
                                                style="height: auto; text-align: center"
                                            >
                                                <img
                                                    v-if="orientation == false"
                                                    v-bind:src="preview1"
                                                    id="img1"
                                                    v-bind:class="[
                                                        'img-responsive',
                                                        f.orientation === 1
                                                            ? 'imgH'
                                                            : 'imgV',
                                                    ]"
                                                />
                                                <img
                                                    v-else
                                                    v-bind:class="[
                                                        'img-responsive',
                                                        f.orientation === 1
                                                            ? 'imgH'
                                                            : 'imgV',
                                                    ]"                                            
                                                    src="@/assets/poster1.jpg"
                                                /> 
                                            </div>
                                            <div
                                                v-else
                                                class="file-drag-drop"
                                                ref="Drop1"
                                                @click="$refs.img1.click()"
                                            >
                                                <span class="drop-files"
                                                    >¡Arrastra y suelta la imagen aquí!</span
                                                >
                                            </div>
                                            <div v-if="Showimg1">
                                                <button
                                                    type="button"
                                                    class="btn btn-danger bntFileV"
                                                    @click="delImg1"
                                                    v-if="f.orientation === 2"
                                                >
                                                    <i class="fa fa-trash"></i> Borrar
                                                    subir
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-danger bntFileH"
                                                    @click="delImg1"
                                                    v-else
                                                >
                                                    <i class="fa fa-trash"></i> Borrar
                                                    subir
                                                </button>
                                            </div>
                                            <div v-else>
                                                <button
                                                    type="button"
                                                    class="btn btn-info bntFile"
                                                    @click="$refs.img1.click()"
                                                >
                                                    <i class="fas fa-upload"></i> Subir
                                                </button>
                                            </div>
                                            <input
                                                type="file"
                                                style="display: none"
                                                ref="img1"
                                                accept="image/*,video/mp4"
                                                @change="fileImg1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <input type="hidden" v-model="f.id" />
                    </form>
                </div>
            </div>
        </div>
        <notifications group="noti" position="top center"></notifications>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import { mapGetters } from "vuex";
import { ModelSelect } from "vue-search-select";
export default {
    name: "DashDisplayForm",
    components: {
        Loader,
        ModelSelect,
    },
    data () {
        return {
            preview1: "",
            Showimg1: false,
            isLoading: false,
            btnSave: false,
            urlDisplay: window.urlDisplay,
            user_id: window.master_client,
            org_id: window.localorgdata,
            type: window.user_type,
            user_id_assign: window.localAccountID,
            TypeTemplates: [],
            f: {
                id: 0,
                TypeTemplates: "",
                name: "",
                dpublis: new Date().toISOString().slice(0, 10),
                dfinish: "",
                status: 1,
                pin: "",
                url: "",
                orientation: 1,
                archivo: null,
                archivoOld: null,
                img1: null,
                type: window.user_type,
            },
            name_old: "",
            urls_videoPoster: "",
            orientation: false,
        };
    },
    created () {
        //prueba preload
        // this.isLoading=true;
        // let t = this;
        // setTimeout(function(){ t.isLoading=false;}, 1000);
        // this.pinSecurity();
        this.getPoster();
        this.getTypeTemplates();
        if (this.$route.params.id !== undefined && this.$route.params.edit !== undefined) {
            this.getDisplayInfoByID();
        }
    },
    methods: {
        getPoster() {
            let url = "/display/poster/" + this.org_id + "/" + this.user_id + "/0";
            window.master
                .get(url)
                .then((response) => {
                    let urls = response.data;
                    this.urls_videoPoster = urls["poster"];
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handleOnInput($event) {
            this.delImg1()
            if ($event.value === 1) {
                this.orientation = false;
            } else {
                this.orientation = true;
            }
        },
        validarEnter(event) {
            event.preventDefault();
            let tecla = document.all ? event.keyCode : event.which;
            console.log("anulando enter " + tecla);
        },
        getDisplayInfoByID() {
            this.isLoading = true;
            this.f.id = this.$route.params.id;
            let url = "/display/getdisplaydash";
            window.master
                .post(url, {
                    user_id_assign: this.user_id_assign,
                    org_id: this.org_id,
                    user_id: this.user_id,
                    type: this.type,
                    id: this.f.id,
                })
                .then((response) => {
                    let r = response.data.list[0];
                    let urls = response.data.urls;
                    this.f.id = r.id;
                    this.f.name = r.name;
                    this.name_old = r.name;
                    this.f.pin = r.pin;
                    this.f.dpublis = r.f_p;
                    this.f.dfinish = r.f_t;
                    this.f.status = r.status;
                    this.f.url = r.url;
                    this.f.orientation = r.orientacion;
                    (this.f.archivo = r.name_archivos),
                        (this.f.archivoOld = r.name_archivos);
                    if (r.prefijo === "imagen") {
                        this.preview1 = urls["thumbs"] + r.name_archivos;
                        this.orientation = false;
                    } else {
                        this.preview1 = urls["poster"];
                        this.orientation = true;
                    }
                    let f = [];
                    f.push({
                        value: r.template_id,
                        text: r.name_archivos,
                    });
                    this.f.TypeTemplates = f[0];
                    this.Showimg1 = true;
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
        delImg1() {
            this.f.img1 = null;
            this.Showimg1 = false;
            this.preview1 = "";
            this.f.archivo = null;       
        },
        fileImg1(event) {
            if (event.target.files[0].size <= 20000000) {
                let file = "";
                if (this.f.img1 !== null) {
                    file = this.f.img1;
                } else {
                    file = event.target.files[0];
                }
                this.f.archivo = file;
                this.Showimg1 = true;
                if (file) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    var ti = this;
                    reader.onload = function (e) {
                        if (ti.orientation === false) {
                            document.querySelector("#img1").src = e.target.result;
                        } 
                        // else {
                        //     document.querySelector("#img1").src = ti.urls_videoPoster;
                        // }
                    };
                }
            } else {
                this.$notify({
                    group: "noti",
                    title: "Error",
                    type: "error",
                    text: "el archivo supera los 20 megabytes",
                });
            }
        },
        cancel() {
            this.$router.push({ name: "Display" });
        },
        refres() {
            this.f.id = 0;
            this.f.name = "";
            this.f.dfinish = "";
            this.f.url = "";
            this.f.status = 1;
            this.f.orientation = 1;
            let f = [];
            f.push({ value: 1, text: "Imagen" });
            this.f.TypeTemplates = f[0];
            this.delImg1();
        },
        slugUrl() {
            let str = this.f.name;
            str = str.replace(/^\s+|\s+$/g, "");
            str = str.toLowerCase();

            var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
            var to = "aaaaaeeeeeiiiiooooouuuunc------";
            for (var i = 0, l = from.length; i < l; i++) {
                str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
            }
            str = str
                .replace(/[^a-z0-9 -]/g, "")
                .replace(/\s+/g, "-")
                .replace(/-+/g, "-");
            this.f.url = str;
        },
        form() {
            if (this.f.name.length === 0 && this.f.TypeTemplates.length === 0) {
                this.$notify({
                    group: "noti",
                    type: "error",
                    title: "Error",
                    text: "Archivo vacío",
                });
            } else {
                if (this.f.status === 1 && this.f.archivo === undefined) {
                    this.$notify({
                        group: "noti",
                        type: "error",
                        title: "Error",
                        text: "Archivo vacío",
                    });
                } else {
                    // if(this.f.pin.length === 0){
                    // 	this.validated(7);
                    // }else{
                    this.isLoading = true;
                    this.btnSave = true;
                    let fileSendHeader = {
                        headers: { "Content-Type": "multipart/form-data" },
                    };
                    let pin = "";
                    if (this.f.pin !== "null" || this.f.pin !== null || this.f.pin !== 0) {
                        pin = this.f.pin;
                    }
                    let formData = new FormData();
                    formData.append("id", this.f.id);
                    formData.append("name", this.f.name);
                    formData.append("pin", pin);
                    formData.append("url", this.f.url);
                    formData.append("user_id", this.user_id);
                    formData.append("org_id", this.org_id);
                    formData.append("archivo", this.f.archivo);
                    formData.append("archivoOld", this.f.archivoOld);
                    formData.append("TypeTemplates", this.f.TypeTemplates.value);
                    formData.append("dpublis", this.f.dpublis);
                    formData.append("dfinish", this.f.dfinish);
                    formData.append("status", this.f.status);
                    formData.append("orientation", this.f.orientation);
                    let url = "/display/form";
                    window.master
                        .post(url, formData, fileSendHeader)
                        .then((response) => {
                            // console.log(response.date);
                            this.refres();
                            this.$notify({
                                group: "noti",
                                title: "Enviar datos",
                                type: "success",
                                text: "Exitoso",
                            });
                            this.isLoading = false;
                            this.btnSave = false;
                            this.$router.push({ name: "Display" });
                        })
                        .catch((error) => {
                            console.log(error);
                            this.isLoading = false;
                            this.btnSave = false;
                        });
                    // }
                }
            }
        },
        getTypeTemplates() {
            let url = "/display/gettypetemplates";
            window.master
                .get(url)
                .then((response) => {
                    let r = response.data.list;
                    let f = [];
                    for (const i in r) {
                        f.push({
                            value: r[i].id,
                            text: r[i].name,
                        });
                    }
                    this.TypeTemplates = f;
                    this.f.TypeTemplates = f[0];
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        validated(y) {
            if (y === 1) {
                this.$notify({
                    group: "noti",
                    type: "error",
                    title: "Error",
                    text: "solo puede tener más de 6 dígitos.",
                });
            } else {
                this.$notify({
                    group: "noti",
                    type: "error",
                    title: "Error",
                    text:"El campo del PIN de seguridad no puede estar vacío, debe tener al menos 6 dígitos.",
                });
            }
        },
        pinSecurity() {
            if (this.f.pin.length === 0) {
                let max = 0;
                let min = 999999;
                let y = Math.floor(Math.random() * (max - min + 1) + min);
                if (y.length < 7) {
                    this.pinSecurity();
                } else {
                    this.f.pin = y;
                }
            }
        },
    },
    computed: {
        ...mapGetters(["get_displayEdit"]),
    },
    watch: {
        "f.pin": {
            handler: function (val, oldVal) {
                // console.log(val);
                if (val !== null) {
                    if (val.length > 6) {
                        this.f.pin = oldVal;
                        this.validated(1);
                    }
                }
            },
            deep: true,
        },
        "f.name": function () {
            if (
                this.f.url === "" ||
                this.f.id === 0 ||
                (this.f.id > 0 && this.name_old !== this.f.name)
            ) {
                this.slugUrl();
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.flex-container {
    display: flex;
    flex-wrap: wrap;
}

.flex-container > div {
    width: 92px;
    margin: 5px;
}

label {
    display: block;
}

.horisontal {
    -webkit-appearance: none;
    outline: 0.1em solid black;
    outline-offset: 0.1em;
    width: 92px;
    height: 54px;
}
.vertical {
    -webkit-appearance: none;
    outline: 0.1em solid black;
    outline-offset: 0.1em;
    width: 54px;
    height: 92px;
}

input[type="radio"]:checked {
    display: inline-block;
    background-color: #000;
}
.file-drag-drop {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
    width: 100%;
    background: #fff;
    margin: auto;
    margin-top: 0px;
    text-align: center;
    border-radius: 0px;
    border: 1px dashed #ccc;
}
.drop-files {
    font-size: 24px;
    color: #ccc;
}
.bntFileV {
    border-radius: 0px;
    margin: 0 auto;
    display: block;
    width: 100%;
    max-width: 216px;
}
.bntFileH {
    border-radius: 0px;
    margin: 0 auto;
    display: block;
    width: 100%;
    max-width: 384px;
}
.bntFile {
    border-radius: 0px;
    margin: 0 auto;
    display: block;
    width: 100%;
}

.img-responsive {
    display: block;
    max-width: 100%;
    height: auto;
    text-align: center;
    margin: 0 auto;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}
.url-text {
    background: transparent;
    border: 0;
    box-shadow: none;
    padding: 0;
    color: #005aff;
}

input.form-control.url-input {
    border: 0px;
    border-bottom: 1px solid;
    padding: 0px;
    margin-left: 3px;
}
.imgH {
    width: 100%;
    max-width: 384px;
    height: 216px;
}
.imgV {
    width: 100%;
    max-width: 216px;
    height: 384px;
}
</style>
